module.exports = __webpack_public_path__ + "img/announcement-02.8f22fcad.svg";